import { Dialog, DialogActions, DialogContent } from "@mui/material"
import type { FC } from "react"

import AssociatedTestTemplateForm from "./AssociatedTestTemplateForm"

import { Button } from "@/components/common/Button"
import DialogHeader from "@/components/common/Modals/DialogHeader"
import type { TestTemplate } from "@/graphql/codegen/graphql"

interface AssociatedTestTemplateFormDialogProps {
  isCreateMode: boolean
  testTemplate: TestTemplate
  canSubmit: boolean
  onGoBack: () => void
  onClose: () => void
  onSubmit: () => void
}

const AssociatedTestTemplateFormDialog: FC<AssociatedTestTemplateFormDialogProps> = ({
  isCreateMode,
  testTemplate,
  canSubmit,
  onGoBack,
  onClose,
  onSubmit,
}: AssociatedTestTemplateFormDialogProps) => {
  return (
    <Dialog open onClose={onClose} fullWidth data-testid='associated-test-template-form-dialog'>
      <DialogHeader
        title={isCreateMode ? "Associate Quality Test Template" : "Edit Test Template Association"}
        onClose={onClose}
      />
      <DialogContent classes={{ root: "p-10" }}>
        <AssociatedTestTemplateForm testTemplate={testTemplate} />
      </DialogContent>
      <DialogActions className='flex gap-x-6 px-10 pb-10'>
        <Button appearance='outlined' className='mr-auto' onClick={onClose}>
          Cancel
        </Button>
        {isCreateMode && (
          <Button appearance='text' onClick={onGoBack} data-testid='go-back-button'>
            Go Back
          </Button>
        )}
        <Button variant='primary' onClick={onSubmit} disabled={!canSubmit} data-testid='submit-button'>
          {isCreateMode ? "Associate Test" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AssociatedTestTemplateFormDialog
